import React, { useCallback, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import CommonService from "../../services/common.service";
import moment from "moment";

function ChallaRequestReceived({ depo }) {
  const [activeYearly, setActiveYearly] = useState(1);
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  const [graphData, setGraphData] = useState([]);

  // console.log("depo", depo);

  const fetchData = useCallback(() => {
    const depoId =
      location.pathname.includes("/centralDashboard") ||
      location.pathname === "/"
        ? "0"
        : depo;
    const type = activeYearly.toString();

    setLoading(true);
    const payload = {
      dateRng_Type: type,
      depoLoc_id: depoId,
    };
    CommonService.getRequestReciveCount(payload)
      .then((resp) => {
        setLoading(false);
        setGraphData(resp.data);
      })
      .catch((e) => console.log(e));
  }, [activeYearly]);

  useEffect(() => {
    fetchData();
  }, [fetchData, activeYearly]);

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  const generateLast7DaysData = () => {
    if (graphData.length != 0) {
      const data = graphData[0].data1.map((item) =>
        moment(item.columnName, "DD/MM").format("DD-MM-YY")
      );

      return data;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    if (graphData.length != 0) {
      const data = graphData[0].data1.map((itm) => itm.columnName);
      return data;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 1
      ? generateLast7DaysData()
      : activeYearly === 2
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const colors = [
    "rgba(255, 232, 138, 1)",
    "rgba(88, 220, 244, 1)",
    "rgba(172, 145, 228, 1)",
    "rgba(236, 137, 214, 1)",
    "rgb(255, 207, 13)",
    "rgb(1, 137, 161)",
    "rgb(88, 74, 116)",
    "rgb(128, 74, 116)",
  ];

  const allDatasets = Array.isArray(graphData)
    ? graphData.map((item, index) => ({
        // label: item.depoName,
        label: "Request Count",
        data: item.data1.map((item) => item.count),
        backgroundColor: colors[index],
        categoryPercentage: activeYearly === 2 ? 0.2 : 0.34,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        },
        borderSkipped: false,
      }))
    : null;

  // console.log("allDatasets", allDatasets);

  const chartData = {
    labels: data,
    datasets: allDatasets,
  };

  const options = {
    type: "bar",
    stacked: true,
    responsive: true,
    offset: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        stacked: true,
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        display: true,
        grid: {
          display: true,
        },

        border: {
          display: false,
        },
        stacked: true,
        title: {
          display: true,
          text: "Request Received Count (MTV)",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <>
      {" "}
      <div className="graph-header">
        <div className="graph-heading">
          Store Reports - Requests Received (MTV)
        </div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
      </div>
      <div className="mt-3" style={{ height: "100%" }}>
        {loading ? (
          <>
            <div className="loading-area">
              <div
                class="spinner-border"
                style={{ color: "rgb(247, 177, 140)" }}
                role="status"
              >
                <span class="sr-only"></span>
              </div>
              <span>Data is Loading...</span>
            </div>
          </>
        ) : graphData.length != 0 ? (
          <>
            <Bar data={chartData} options={options} width={600} height={275} />
          </>
        ) : (
          <div className="text-center">No Records Found </div>
        )}
      </div>
    </>
  );
}

export default ChallaRequestReceived;
